module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "role-items-wrapper"
  }, _vm._l((_vm.Items), function(category, key) {
    return _c('div', {
      staticClass: "w5-role-wrapper"
    }, [_c('div', {
      staticClass: "w5-role-item-name"
    }, [_c('span', {
      attrs: {
        "title": _vm._f("ftc")(_vm.selectStatus(key, category))
      },
      on: {
        "click": function($event) {
          return _vm.selectDeselect($event, key, category)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(category.name)))])]), _vm._v(" "), _c('div', {
      staticClass: "w5-role-item-value"
    }, _vm._l((category.roles), function(role, action) {
      return _c('div', {
        staticClass: "w5-checkbox"
      }, [_c('label', {
        staticClass: "checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkValues),
          expression: "checkValues"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": key + '/' + action,
          "checked": Array.isArray(_vm.checkValues) ? _vm._i(_vm.checkValues, key + '/' + action) > -1 : (_vm.checkValues)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.checkValues,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = key + '/' + action,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.checkValues = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.checkValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkValues = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(_vm._f("ftc")(role)) + "\n\t\t\t\t")])])
    }), 0)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88dab116"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/role.vue
// module id = 435
// module chunks = 0